import { primeLeadToken, submitLead } from './submit-lead.js';
import { trackEvent } from './analytics.js';

export function connectSubscribeForms() {
    const form = document.querySelector('.subscribe-form--js');
    if (!form) {
        console.info('[CPB:lead] No .subscribe-form--js found, skipping subscribe form wiring');
        return;
    }

    let inFlight = false;
    let subscribed = false;

    primeLeadToken(form, 'site-subscribe');
    form.addEventListener('submit', handleSubmit);

    function handleSubmit(e) {
        e.preventDefault();

        if (inFlight || subscribed) {
            console.info('[CPB:lead] Subscribe form already sent or in flight, ignoring submit');
            return false;
        }

        inFlight = true;
        setButtonState('SENDING…', true);

        submitLead('site-subscribe', {
            email: form.elements.email?.value || '',
            website: form.elements.website?.value || '',
        }, form)
            .then(() => {
                console.info('[CPB:lead] Subscribe form submitted');
                trackEvent('newsletter', { event_category: 'lead' });
                markSubscribed();
            })
            .catch((err) => {
                console.error('[CPB:lead] Subscribe form submit failed', err);
                setButtonState('ERROR — TRY AGAIN', false);
            })
            .finally(() => {
                inFlight = false;
            });

        return false;
    }

    function setButtonState(text, disabled) {
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        button.innerText = text;
        if (disabled) button.setAttribute('disabled', true);
        else button.removeAttribute('disabled');
    }

    function markSubscribed() {
        subscribed = true;
        setButtonState('SUBSCRIBED', true);
        form.reset();
    }
}
